import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import InsertHtml from '../../../components/insertHtml';
import Content from './content';

class lvrenNote extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const { lvrenNoteTab, linkFengUrl, lvrenNote } = content;

        return (
            <div className={styles.wrap}>
                <NoSSR>
                    <Chip id="40001" type="static" title="旅人笔记tab" groupName="正文" content={lvrenNoteTab}>
                        <InsertHtml />
                    </Chip>
                </NoSSR>

                <Chip id="45018" type="struct" title="旅人笔记内容" groupName="正文" content={lvrenNote}>
                    <Content linkFengUrl={linkFengUrl} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(lvrenNote);
